import { Column } from "@stenajs-webui/core";

import { DetailsFieldCell } from "../../../../common-ui/details/DetailsFieldCell";
import type { IntermodalBookingAlternativeRoute } from "../../../../common/graphql/fragments/gql/IntermodalBooking";
import { formatServerDate } from "../../../../common/utils/dates/dateUtils";
import { timeOptions } from "../../../manage/details/components/sections/common";
import {
  transformDepartureTimeOption,
  transformIntermodalRouteToDropdownOption,
} from "../../utils/detailsUtils";
import { UpdateIntermodalDateInputField } from "../fields/UpdateIntermodalDateInputField";
import { UpdateIntermodalDropdownField } from "../fields/UpdateIntermodalDropdownField";

interface UpdateIntermodalDepartureSectionProps {
  alternativeRoutes: IntermodalBookingAlternativeRoute[];
}

export const UpdateIntermodalDepartureSection = ({
  alternativeRoutes,
}: UpdateIntermodalDepartureSectionProps) => {
  const today = new Date();
  return (
    <>
      <DetailsFieldCell
        label={"Intermodal route"}
        renderField={(id) => (
          <UpdateIntermodalDropdownField
            id={id}
            trackerCategory={"IntermodalUpdate"}
            disabled={alternativeRoutes.length <= 1}
            options={alternativeRoutes.map((r) =>
              transformIntermodalRouteToDropdownOption(r),
            )}
            name={"route"}
            transformOption={transformIntermodalRouteToDropdownOption}
          />
        )}
      />
      <Column gap={2}>
        <DetailsFieldCell
          label={"Departure date"}
          className={"t_intermodal_departure_date"}
          renderField={(id) => (
            <UpdateIntermodalDateInputField
              id={id}
              width={"100%"}
              disabled
              trackerCategory={"IntermodalUpdate"}
              name={"departureDate"}
              minDate={formatServerDate(today)}
            />
          )}
        />
        <DetailsFieldCell
          label={"Dep. time"}
          renderField={(id) => (
            <UpdateIntermodalDropdownField
              id={id}
              trackerCategory={"IntermodalUpdate"}
              disabled
              name={"departureTime"}
              options={timeOptions}
              transformOption={transformDepartureTimeOption}
            />
          )}
        />
      </Column>
    </>
  );
};
